export default "__VITE_ASSET__DnQqQX$A__"